module.exports = __webpack_public_path__ + "img/deposit.2a299a9b.jpg";